import { render, staticRenderFns } from "./AdsCategoryAdd.vue?vue&type=template&id=6f15a972&scoped=true&"
import script from "./AdsCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./AdsCategoryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f15a972",
  null
  
)

export default component.exports